<template>
  <layout>
    <div class="hero bg-black text-white pt-8">
      <div class="container mx-auto">
        <div class="w-full max-w-sm mx-auto sm:my-48">
          <div class="mb-4">
            <div class="mb-8 text-center">
              <h1 class="text-lg uppercase text-yellow-mm-600 tracking-widest">
                Restricted Area
              </h1>
              <p>Enter the pin to gain access</p>
            </div>

            <form @submit.prevent="submit">
              <div class="flex items-end justify-between">
                <div class="mr-1 w-full">
                  <input-field
                    v-model="formData.code"
                    type="password"
                    placeholder="Enter pin"
                    class="text-sm"
                    autofocus />
                </div>
                <default-button
                  tertiary
                  :loading="submitting"
                  :disabled="submitting">
                  OK
                </default-button>
              </div>
              <div
                class="p-3 bg-red-100 text-red-800 border border-red-300 rounded-sm mb-6 font-semibold text-sm text-center"
                v-if="error">
                {{ error }}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from "@/Shared/Layout.vue"

export default {
  components: {
    Layout
  },

  created () {
    try {
      window.fathom("trackPageview")
    } catch (e) {}
  },

  data () {
    return {
      formData: {
        code: null
      },
      error: null,
      submitting: false
    }
  },

  methods: {
    submit () {
      this.submitting = true
      this.$inertia.post("/fsk/auth", this.formData)
        .then(() => {
          this.submitting = false
        })
    }
  }
}
</script>
